__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-04-08-1775647842-stable-dev/";